export const SEXE = {
    homme: "Homme",
    femme: "Femme",
}

export const SITUATION_MARITALE = {
    marie: "Marié",
    pacse: "Pacsé",
    celibataire: "Célibataire",
    veuf: "Veuf"
}
export const RELATIONS = {
    "enfant": "Enfant",
    "parent": "Parent",
    "frere-soeur": "Frère/Soeur",
    "neveu-niece": "Neveu/Nièce",
    "epoux-epouse": "Époux/Épouse",
}
